import { render } from "./PetName.vue?vue&type=template&id=3f059472"
import script from "./PetName.vue?vue&type=script&lang=js"
export * from "./PetName.vue?vue&type=script&lang=js"

import "./PetName.vue?vue&type=style&index=0&id=3f059472&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__